import { render } from "./lang-switcher.vue?vue&type=template&id=1ca9a377&scoped=true&ts=true"
import script from "./lang-switcher.vue?vue&type=script&lang=ts"
export * from "./lang-switcher.vue?vue&type=script&lang=ts"

import "./lang-switcher.vue?vue&type=style&index=0&id=1ca9a377&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca9a377"]])

export default __exports__